import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import { ErrorListener } from "@sdk/helpers";
import { ErrorCartTypes } from "@sdk/jobs/Cart";
import { StateItems } from "@sdk/state/types";
export var SaleorCartAPI =
/*#__PURE__*/
function (_ErrorListener) {
  _inherits(SaleorCartAPI, _ErrorListener);

  function SaleorCartAPI(checkoutRepositoryManager, networkManager, saleorState, loadOnStart, jobsManager) {
    var _this;

    _classCallCheck(this, SaleorCartAPI);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SaleorCartAPI).call(this));
    _this.load =
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.saleorState.provideCheckout(_this.fireError, true);

            case 2:
              return _context.abrupt("return", {
                pending: false
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    _this.addItem =
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(variantId, quantity, productAttributes) {
        var _this$saleorState$che, _this$saleorState$che2;

        var _ref3, data, error;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.saleorState.provideCheckout(_this.fireError);

              case 2:
                // 1. save in local storage
                _this.checkoutRepositoryManager.addItemToCart(variantId, quantity, productAttributes); // 2. save online if possible (if checkout id available)


                if (!((_this$saleorState$che = _this.saleorState.checkout) === null || _this$saleorState$che === void 0 ? void 0 : _this$saleorState$che.lines)) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 6;
                return _this.networkManager.getRefreshedCheckoutLines(_this.saleorState.checkout.lines);

              case 6:
                _ref3 = _context2.sent;
                data = _ref3.data;
                error = _ref3.error;

                if (error) {
                  _this.fireError(error, ErrorCartTypes.SET_CART_ITEM);
                } else {
                  _this.checkoutRepositoryManager.getRepository().setCheckout(_objectSpread({}, _this.saleorState.checkout, {
                    lines: data
                  }));
                }

              case 10:
                if (!((_this$saleorState$che2 = _this.saleorState.checkout) === null || _this$saleorState$che2 === void 0 ? void 0 : _this$saleorState$che2.id)) {
                  _context2.next = 13;
                  break;
                }

                _this.jobsManager.addToQueue("cart", "setCartItem");

                return _context2.abrupt("return", {
                  pending: true
                });

              case 13:
                return _context2.abrupt("return", {
                  pending: false
                });

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.removeItem =
    /*#__PURE__*/
    function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(variantId, productAttributes) {
        var _this$saleorState$che3, _this$saleorState$che4;

        var _ref5, data, error;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this.saleorState.provideCheckout(_this.fireError);

              case 2:
                // 1. save in local storage
                _this.checkoutRepositoryManager.removeItemFromCart(variantId, productAttributes); // 2. save online if possible (if checkout id available)


                if (!((_this$saleorState$che3 = _this.saleorState.checkout) === null || _this$saleorState$che3 === void 0 ? void 0 : _this$saleorState$che3.lines)) {
                  _context3.next = 10;
                  break;
                }

                _context3.next = 6;
                return _this.networkManager.getRefreshedCheckoutLines(_this.saleorState.checkout.lines);

              case 6:
                _ref5 = _context3.sent;
                data = _ref5.data;
                error = _ref5.error;

                if (error) {
                  _this.fireError(error, ErrorCartTypes.SET_CART_ITEM);
                } else {
                  _this.checkoutRepositoryManager.getRepository().setCheckout(_objectSpread({}, _this.saleorState.checkout, {
                    lines: data
                  }));
                }

              case 10:
                if (!((_this$saleorState$che4 = _this.saleorState.checkout) === null || _this$saleorState$che4 === void 0 ? void 0 : _this$saleorState$che4.id)) {
                  _context3.next = 13;
                  break;
                }

                _this.jobsManager.addToQueue("cart", "setCartItem");

                return _context3.abrupt("return", {
                  pending: true
                });

              case 13:
                return _context3.abrupt("return", {
                  pending: false
                });

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x4, _x5) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.updateItem =
    /*#__PURE__*/
    function () {
      var _ref6 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(variantId, quantity, productAttributes) {
        var _this$saleorState$che5, _this$saleorState$che6;

        var _ref7, data, error;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this.saleorState.provideCheckout(_this.fireError);

              case 2:
                // 1. save in local storage
                _this.checkoutRepositoryManager.updateItemInCart(variantId, quantity, productAttributes); // 2. save online if possible (if checkout id available)


                if (!((_this$saleorState$che5 = _this.saleorState.checkout) === null || _this$saleorState$che5 === void 0 ? void 0 : _this$saleorState$che5.lines)) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 6;
                return _this.networkManager.getRefreshedCheckoutLines(_this.saleorState.checkout.lines);

              case 6:
                _ref7 = _context4.sent;
                data = _ref7.data;
                error = _ref7.error;

                if (error) {
                  _this.fireError(error, ErrorCartTypes.SET_CART_ITEM);
                } else {
                  _this.checkoutRepositoryManager.getRepository().setCheckout(_objectSpread({}, _this.saleorState.checkout, {
                    lines: data
                  }));
                }

              case 10:
                if (!((_this$saleorState$che6 = _this.saleorState.checkout) === null || _this$saleorState$che6 === void 0 ? void 0 : _this$saleorState$che6.id)) {
                  _context4.next = 13;
                  break;
                }

                _this.jobsManager.addToQueue("cart", "setCartItem");

                return _context4.abrupt("return", {
                  pending: true
                });

              case 13:
                return _context4.abrupt("return", {
                  pending: false
                });

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x6, _x7, _x8) {
        return _ref6.apply(this, arguments);
      };
    }();

    _this.setCartPromoCode =
    /*#__PURE__*/
    function () {
      var _ref8 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(cartPromoCode) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this.checkoutRepositoryManager.setCartPromoCode(cartPromoCode);

                return _context5.abrupt("return", {
                  pending: false
                });

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x9) {
        return _ref8.apply(this, arguments);
      };
    }();

    _this.saleorState = saleorState;
    _this.checkoutRepositoryManager = checkoutRepositoryManager;
    _this.networkManager = networkManager;
    _this.jobsManager = jobsManager;
    _this.loaded = false;
    _this.checkoutLoaded = false;
    _this.summaryPricesLoaded = false;

    _this.jobsManager.attachErrorListener("cart", _this.fireError);

    _this.saleorState.subscribeToChange(StateItems.CHECKOUT, function (_ref9) {
      var lines = _ref9.lines,
          cartPromoCode = _ref9.cartPromoCode;
      _this.items = lines === null || lines === void 0 ? void 0 : lines.filter(function (line) {
        return line.quantity > 0;
      }).sort(function (a, b) {
        if (a.id && b.id) {
          var _a$id, _b$id;

          var aId = ((_a$id = a.id) === null || _a$id === void 0 ? void 0 : _a$id.toUpperCase()) || "";
          var bId = ((_b$id = b.id) === null || _b$id === void 0 ? void 0 : _b$id.toUpperCase()) || ""; // eslint-disable-next-line no-nested-ternary

          return aId < bId ? -1 : aId > bId ? 1 : 0; // eslint-disable-next-line no-else-return
        } else {
          var _a$variant$id, _b$variant$id;

          var _aId = ((_a$variant$id = a.variant.id) === null || _a$variant$id === void 0 ? void 0 : _a$variant$id.toUpperCase()) || "";

          var _bId = ((_b$variant$id = b.variant.id) === null || _b$variant$id === void 0 ? void 0 : _b$variant$id.toUpperCase()) || ""; // eslint-disable-next-line no-nested-ternary


          return _aId < _bId ? -1 : _aId > _bId ? 1 : 0;
        }
      });
      _this.cartPromoCode = cartPromoCode;
      _this.checkoutLoaded = true;
      _this.loaded = _this.checkoutLoaded && _this.summaryPricesLoaded;
    });

    _this.saleorState.subscribeToChange(StateItems.SUMMARY_PRICES, function (_ref10) {
      var totalPrice = _ref10.totalPrice,
          subtotalPrice = _ref10.subtotalPrice,
          shippingPrice = _ref10.shippingPrice,
          discount = _ref10.discount;
      _this.totalPrice = totalPrice;
      _this.subtotalPrice = subtotalPrice;
      _this.shippingPrice = shippingPrice;
      _this.discount = discount;
      _this.summaryPricesLoaded = true;
      _this.loaded = _this.summaryPricesLoaded && _this.checkoutLoaded;
    });

    if (loadOnStart) {
      _this.load();
    }

    return _this;
  }

  return SaleorCartAPI;
}(ErrorListener);